export enum CustomerApiRoutes {
  GenerateKey = 'generate-key',
  GetKeys = 'get-keys',
  RevokeKey = 'revoke-key',
}
